import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-054f6ad1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "add-account"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
import { ref } from 'vue';
import { getSmsRecordPage } from '@/api/sms.js';
import usePagination from '@/hooks/usePagination';
import { tableDataSchemas, PLATFORM_TYPE } from './config';
import { useRouter, useRoute } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    // loading效果
    const loading = ref(false);
    const phone = ref('');
    const route = useRoute();
    const appId = ref(route.params.appId);

    /**
     * 获取短信接入方密钥分页
     */
    const getData = async () => {
      loading.value = true;
      try {
        const res = await getSmsRecordPage({
          currentPage: currentPage.value,
          pageSize: pageSize.value,
          phones: phone.value,
          appId: appId.value
        });
        tableData.value = res.records;
        setCurrentPage(res.current);
        setTotal(res.total);
        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    };
    getData();

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getData();
    };
    const handleSearchSmsRecordByPhone = () => {
      getData();
    };
    const router = useRouter();
    const handleViewInfo = row => {
      router.push(`/operation/smsSecretManage/signRecordDetail/${row.id}`);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          modelValue: phone.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => phone.value = $event),
          placeholder: "请输入手机号",
          style: {
            "margin-right": "10px"
          },
          onKeyup: _withKeys(handleSearchSmsRecordByPhone, ["enter"])
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSearchSmsRecordByPhone
        }, {
          default: _withCtx(() => [_createTextVNode(" 搜索 ")]),
          _: 1
        })])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {
            "width": "100%"
          },
          border: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableDataSchemas), (item, index) => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: item.label,
              "min-width": item.minWidth
            }, {
              default: _withCtx(({
                row
              }) => [item.prop === 'platform' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(PLATFORM_TYPE)[row[item.prop]]), 1)) : item.prop === 'templateType' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.TEMPLATE_TYPE[row[item.prop]]), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(row[item.prop]), 1))]),
              _: 2
            }, 1032, ["label", "min-width"]);
          }), 128)), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "success",
              onClick: $event => handleViewInfo(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 详情 ")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total,  prev, pager, next, jumper",
          style: {
            "margin-top": "10px"
          }
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      })]);
    };
  }
};